import type { ClientHomePlan } from "api-types/homePlans/homePlanResponses";
import Button from "ui/buttons/Button";
import Modal, { type ModalProps } from "ui/components/Modal";

interface LotUpdateConfirmationModalProps extends ModalProps {
  homePlans: ClientHomePlan[];
  onSuccess: () => void;
}

export default function LotUpdateConfirmationModal({
  onClose,
  open,
  homePlans,
  onSuccess,
}: LotUpdateConfirmationModalProps) {
  return (
    <Modal
      open={!!open}
      onClose={onClose}
      title="Update Lot"
      footer={
        <>
          <Button btnSize="large" btnStyle="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button btnSize="large" onClick={() => onSuccess()}>
            Save
          </Button>
        </>
      }
      variants={["footerButtons", "bodyPadding"]}
    >
      Updating the Garage Handing setting will update the following Home Plans:{" "}
      <strong>{homePlans?.map((hp) => hp.planName)?.join(", ") ?? "N/A"}</strong>
    </Modal>
  );
}
